import React from 'react';
import { LayoutTemplate, Home, Inbox, QrCode } from 'lucide-react';

const DesktopTabs = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { id: 'portfolio', label: 'Website Builder', icon: LayoutTemplate },
    { id: 'properties', label: 'Properties & Sites', icon: Home },
    { id: 'responses', label: 'Form Responses', icon: Inbox },
    { id: 'qr', label: 'QR Generator', icon: QrCode },
  ];

  return (
    <div className="flex gap-8">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className={`pb-3 text-xs font-medium transition-colors flex items-center gap-2 ${
            activeTab === tab.id 
              ? 'border-b-2 border-notion-text text-notion-text' 
              : 'border-b-2 border-transparent text-notion-text-light hover:text-notion-text'
          }`}
        >
          <tab.icon className="w-3.5 h-3.5" /> {tab.label}
        </button>
      ))}
    </div>
  );
};

export default DesktopTabs;
